import { render, staticRenderFns } from "./Tema3.vue?vue&type=template&id=1375ca8f&lang=pug&"
import script from "./Tema3.vue?vue&type=script&lang=js&"
export * from "./Tema3.vue?vue&type=script&lang=js&"
import style0 from "./Tema3.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports